export default __webpack_public_path__ + "assets/images/1f2ecb4b29ddb1244871e269126c41f5.svg";